import "@fortawesome/fontawesome-pro/css/all.css";
import "./bootstrap";
import { useWorldStore } from "@stores/world";
import { useTourStore } from "@stores/tour";
import { useAchievementsStore } from "@stores/achievements";
import { useExpediaStore } from "@stores/expedia";
import { createApp } from "vue/dist/vue.esm-bundler";
import { createPinia } from "pinia";
import router from "./router";
import clickOutside from "@directives/clickOutside";

const pinia = createPinia();
const app = createApp({}).use(router).use(pinia);

const world = useWorldStore();
const tour = useTourStore();
const achievements = useAchievementsStore();
const expedia = useExpediaStore();
app.directive("click-outside", clickOutside);

world.setup();
tour.setup();
achievements.setup();
expedia.setup();

/* Mount App */
app.mount("#exspeedia");
